<template>
  <div id="app">
    <router-view></router-view>
  </div>
</template>

<script>
export default {
  watch: {
    "$store.state.theme"(val) {
      this.toggleClassInBody(val);
    },
    "$store.state.notify"(val) {
      if (val) {
        this.$vs.notify({ ...val });
      }
    },
    "$store.state.login.access_token"(token) {
      if (this.$route.meta.requiresAuth && !token) {
        this.$router.replace({ name: "login" });
      }
    }
  },
  methods: {
    toggleClassInBody(className) {
      if (className == "dark") {
        if (document.body.className.match("theme-semi-dark"))
          document.body.classList.remove("theme-semi-dark");
        document.body.classList.add("theme-dark");
      } else if (className == "semi-dark") {
        if (document.body.className.match("theme-dark"))
          document.body.classList.remove("theme-dark");
        document.body.classList.add("theme-semi-dark");
      } else {
        if (document.body.className.match("theme-dark"))
          document.body.classList.remove("theme-dark");
        if (document.body.className.match("theme-semi-dark"))
          document.body.classList.remove("theme-semi-dark");
      }
    },
    handleWindowResize(event) {
      this.$store.dispatch("updateWindowWidth", event.currentTarget.innerWidth);
    }
  },
  mounted() {
    window.document.title = [
      this.$whitelabel.nome,
      this.$whitelabel.slogan
    ].join(" « ");

    this.$store.dispatch("resetLoading");

    this.toggleClassInBody(this.$whitelabel.config.theme);
    this.$nextTick(() => {
      window.addEventListener("resize", this.handleWindowResize);
    });
    this.$store.dispatch("updateWindowWidth", window.innerWidth);
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.handleWindowResize);
  }
};
</script>
